import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ShipDateLabelWithoutColon = () => (
  <FormattedMessage defaultMessage='Ship Date' description='fulfillmentPlanner.shipDateWithoutColon' id='AN7jHz' />
);
